import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import './fancy-timeline.css'; // Import the CSS for styling
const Timeline = ({ items, animate = true }) => {
    const containerRef = useRef(null);
    const [visibleItems, setVisibleItems] = useState(new Set());
    // Intersection Observer for scroll animations (bonus feature)
    useEffect(() => {
        if (!animate)
            return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const indexAttr = entry.target.getAttribute('data-index');
                if (entry.isIntersecting && indexAttr !== null) {
                    const idx = parseInt(indexAttr, 10);
                    setVisibleItems((prev) => new Set(prev).add(idx));
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2, rootMargin: '0px 0px -20px 0px' });
        const itemsElements = containerRef.current?.querySelectorAll('.timeline-item');
        itemsElements?.forEach((el) => observer.observe(el));
        return () => {
            observer.disconnect();
        };
    }, [items, animate]);
    if (!items.length)
        return null;
    return (_jsxs("div", { className: "timeline-container", ref: containerRef, children: [_jsx("div", { className: "timeline-line" }), items.map((item, index) => {
                const isLeft = index % 2 === 0;
                const isVisible = visibleItems.has(index);
                const dotColor = item.statusColor || '#3b82f6';
                return (_jsxs("div", { className: `timeline-item ${isLeft ? 'left' : 'right'} ${animate && isVisible ? 'visible' : ''}`, "data-index": index, children: [_jsx("div", { className: "timeline-dot", style: { borderColor: dotColor } }), _jsx("div", { className: "timeline-card", children: _jsxs("div", { className: "timeline-card-inner", children: [item.icon && (_jsx("div", { className: "timeline-icon-circle", children: item.icon })), _jsxs("div", { className: "timeline-content", children: [item.date && (_jsx("div", { className: "timeline-date", children: item.date })), _jsx("div", { className: "timeline-title", children: item.title }), item.description && (_jsx("div", { className: "timeline-description", children: item.description }))] })] }) })] }, index));
            })] }));
};
export default Timeline;
